import { render, staticRenderFns } from "./jiangli.vue?vue&type=template&id=0fb40d88&scoped=true&"
import script from "./jiangli.vue?vue&type=script&lang=js&"
export * from "./jiangli.vue?vue&type=script&lang=js&"
import style0 from "./jiangli.vue?vue&type=style&index=0&id=0fb40d88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb40d88",
  null
  
)

export default component.exports